import { Box, Drawer } from "@mui/material";
// components
import NavList from "./NavList";
import TopNavList from "./TopNavList";
// config
import { NAV } from "../../../config/nav";
import colors from "../../../config/colors";
import { WISHLINK_SIDEBAR_LOGO_URL } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";

const NavBarVertical = ({
  sidebarItems,
  bottomSidebarItems,
  footerSidebarItems,
}) => {
  const navigate = useNavigate();
  const onboardingAffiliateSteps = sidebarItems.filter(
    (item) => item.areSubRoutesGroupedSidebarTabs,
  );
  const remainingItems = sidebarItems.filter(
    (item) => !item.areSubRoutesGroupedSidebarTabs,
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: 0,
        width: NAV.W_DASHBOARD,
      }}
    >
      <Drawer
        open
        variant="permanent"
        sx={{
          bgcolor: colors.primary500,
          width: NAV.W_DASHBOARD,
          "& .MuiDrawer-paper": {
            width: NAV.W_DASHBOARD,
            backgroundColor: colors.primary500,
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "16px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 3,
              pt: 2,
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            <Box
              component="img"
              src={WISHLINK_SIDEBAR_LOGO_URL}
              alt="Wishlink"
              sx={{ height: "16.615px", objectFit: "contain" }}
            />
          </Box>
          {onboardingAffiliateSteps.map((list) => (
            <TopNavList list={list} />
          ))}

          {remainingItems.map((list) => (
            <NavList key={list.label + list.path} data={list} depth={1} />
          ))}
          <Box flexGrow={1} />
          {bottomSidebarItems.map((list) => (
            <NavList key={list.label + list.path} data={list} depth={1} />
          ))}
          {footerSidebarItems?.map((list) => (
            <NavList key={list.label + list.path} data={list} depth={1} />
          ))}
        </Box>
      </Drawer>
    </Box>
  );
};

export default NavBarVertical;
